import { render, staticRenderFns } from "./ApplicationReturnForm.vue?vue&type=template&id=79963cde&scoped=true&"
import script from "./ApplicationReturnForm.vue?vue&type=script&lang=js&"
export * from "./ApplicationReturnForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79963cde",
  null
  
)

export default component.exports